// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import { v4 as uuidv4 } from "uuid";
// import Utils from "../../utils/Utils";

// const PlayerCard = ({
//   playerName = "",
//   teamName = "",
//   leagueType = "",
//   year = "",
//   list = [],
// }) => {
//   const [teamColor, setTeamColor] = useState([]);

//   useEffect(() => {
//     if (teamName.length > 0) {
//       Utils.readCsv("teams/Color_Code_for_Teams.csv")
//         .then((colorCSV) => {
//           setTeamColor(
//             colorCSV.data.filter((csvDt) => csvDt["Teams"] === teamName)?.[0][
//               "Colors"
//             ]
//           );
//         })
//         .catch((err) => {
//           console.error(err);
//         });
//     }
//   }, []);

//   return (
//     <div className="card Player m-1 mt-4">
//       <span
//         className="card-header"
//         style={{
//           backgroundImage: `linear-gradient(to right bottom, #d07c3b, ${teamColor})`,
//         }}
//       >
//         <h2 className="card-title text-white">
//           {Utils.capitalize(playerName)}
//         </h2>
//       </span>
//       <ul className="list-group list-group-flush">
//         {list.map((item) => (
//           <li className="list-group-item font-weight-bold" key={uuidv4()}>
//             {item}
//           </li>
//         ))}
//       </ul>
//       <div className="card-body">
//         <Link
//           to={`/individual-player/${leagueType}/${year}/${teamName}/${playerName}`}
//         >
//           <button
//             className="btn btn-primary w-100 p-2"
//             style={{ backgroundColor: teamColor ?? "" }}
//           >
//             Go to Player Page
//             <i className="fa fa-chevron-right ml-2"></i>
//           </button>
//         </Link>
//       </div>
//     </div>
//   );
// };

// export default PlayerCard;
